module.exports = __webpack_public_path__ + "static/media/data_light_logo_test.38a51679.svg";